import React from "react";
import { CheckCircle2 } from "lucide-react";

export default function AboutSustainability() {
  const commitments = [
    "Cut emissions and waste across active survey engagements.",
    "Promote sustainable operational practices with clients and suppliers.",
    "Continuously improve technical methodologies via advanced training.",
  ];

  return (
    <section
      id="about"
      className="py-24 bg-white border-t border-b border-gray-100"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 items-start">
          {/* Profile Statement */}
          <div className="lg:col-span-7">
            <span className="text-xs font-bold text-[#87412A] uppercase tracking-widest block mb-2">
              Corporate Profile
            </span>
            <h2 className="text-4xl font-bold text-[#1E4363] font-serif mb-6">
              About CMJ Global
            </h2>
            <div className="space-y-6 text-[#2C3539]/80 leading-relaxed text-lg">
              <p>
                CMJ Global is a premier independent marine and 
                consultancy firm. We offer dedicated inspection
                services primarily tailored to Oil Majors, Charterers,
                Shipowners, P&I clubs, Underwriters, Arbitrators, and Loss
                Adjusters.
              </p>
              <p>
                Our survey capabilities stretch across all major vessel
                categories—including dry cargo and specialized tankers. By
                combining decades of seafaring experience with modern
                tech-supported frameworks, we provide the dependable, defensible
                data required to maintain asset safety and commercial quality.
              </p>
            </div>
          </div>

          {/* Sustainability Box */}
          {/* <div className="lg:col-span-5 bg-[#F9F8F3] p-8 border border-gray-200 rounded-sm shadow-sm">
            <h3 className="text-2xl font-bold text-[#1E4363] font-serif mb-4">Sustainability & Commitment</h3>
            <p className="text-[#2C3539]/70 text-sm mb-6 leading-relaxed">
              We explicitly recognize the critical environmental impact inherent to modern global shipping. Our team actively operates to minimize environmental footprints while safeguarding vessel performance.
            </p>
            
            <ul className="space-y-4">
              {commitments.map((text, index) => (
                <li key={index} className="flex items-start gap-3">
                  <CheckCircle2 className="text-[#87412A] shrink-0 mt-0.5" size={18} />
                  <span className="text-sm font-medium text-[#2C3539]">{text}</span>
                </li>
              ))}
            </ul>
          </div> */}

          {/* Right Column: Why Choose Us Box */}
          <div className="lg:col-span-5 bg-[#F9F8F3] p-8 border border-gray-200 rounded-sm shadow-sm relative overflow-hidden">
            <div className="absolute top-0 right-0 w-16 h-16 bg-[#1E4363]/5 rounded-bl-full"></div>

            <h3 className="text-2xl font-bold text-[#1E4363] font-serif mb-6">
              The CMJ Advantage
            </h3>

            <ul className="space-y-5">
              <li className="flex items-start gap-4">
                <div className="w-2 h-2 bg-[#87412A] rounded-full mt-2 shrink-0"></div>
                <div>
                  <h4 className="font-bold text-[#2C3539] text-sm">
                    Master Mariner Led
                  </h4>
                  <p className="text-[#2C3539]/70 text-xs mt-1">
                    Decades of direct, at-sea command experience ensuring
                    practical, real-world solutions.
                  </p>
                </div>
              </li>
              <li className="flex items-start gap-4">
                <div className="w-2 h-2 bg-[#87412A] rounded-full mt-2 shrink-0"></div>
                <div>
                  <h4 className="font-bold text-[#2C3539] text-sm">
                    Independent & Defensible
                  </h4>
                  <p className="text-[#2C3539]/70 text-xs mt-1">
                    Providing completely unbiased, third-party data that stands
                    up to strict commercial scrutiny.
                  </p>
                </div>
              </li>
              <li className="flex items-start gap-4">
                <div className="w-2 h-2 bg-[#87412A] rounded-full mt-2 shrink-0"></div>
                <div>
                  <h4 className="font-bold text-[#2C3539] text-sm">
                    Rapid Turnaround
                  </h4>
                  <p className="text-[#2C3539]/70 text-xs mt-1">
                    Tech-supported reporting frameworks designed to prevent
                    delays at berth or port.
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
